import { useBlocksConfig } from "@pathwright/blocks-engine"
import {
  getGenericLinkContext,
  type GenericLinkContext
} from "@pathwright/utils/src/url/generic-link"

type TemplateVariables = {
  group?: { id?: number | string } | null
  resource?: { id?: number | string } | null
} | null

// Prefer the cohort supplied by the host app, since blocks also render outside
// of a cohort URL (previews, the sync sandbox, the Inbox).
export function getGenericLinkContextFrom(
  templateVariables: TemplateVariables
): GenericLinkContext {
  const cohortId = templateVariables?.group?.id
  const resourceId = templateVariables?.resource?.id
  if (cohortId && resourceId) return { cohortId, resourceId }

  return getGenericLinkContext()
}

export function useGenericLinkContext(): GenericLinkContext {
  const { templateVariables } = useBlocksConfig()
  return getGenericLinkContextFrom(templateVariables as TemplateVariables)
}
